import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import {
  IApiResponse,
  ICmsNetworkDetailResponse,
} from "../../Orchestrator/Types/Index";
import { ICmsDestinationDetailResponse } from "../../Orchestrator/Types/Interface/ICmsDestination";

export async function getCmsNetworkMapStationsBySlug(
  slug: string
): Promise<IApiResponse<ICmsNetworkDetailResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getNetworkMapStations;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("filters[slug][$eq]", slug);
  params.append("populate[popular_trips][populate]", "*");
  params.append("populate[station][populate][image]", "true");
  params.append("populate[station][populate][map_image]", "true");
  params.append("populate[station][populate][time_slot][populate]", "week_day");
  params.append("populate[shops][populate]", "logo");
  params.append("populate", "floor_plan");
  params.append("locale", locale);

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsNetworkDetailResponse>(
    endpointWithParams,
    "GET"
  );
}
